// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3XoAy","info":"Note_info__3p-2h","note":"Note_note__2nxIg","actions":"Note_actions__I3bW-"};